import React from 'react';
import { Trans } from 'react-i18next';
import { H3, Subtitle } from 'react-design-components';
import { Box } from '@material-ui/core';
import useHelp from './hooks/useHelp';

const AdditionalPaymentHelp = () => {
  const { t } = useHelp();
  return (
    <Trans i18nKey="additional_payment" t={t}>
      <Box mb={3}>
        <H3>Nachzahlung</H3>
      </Box>

      <Box mb={2}>
        <Subtitle margined>
          Die genaue Höhe der Nachzahlung gibt Aufschluss darüber, ob ihr Vermieter die Abrechnung
          <b>exakt kalkuliert</b>
          hat.
        </Subtitle>
      </Box>

      <Box mb={2}>
        <Subtitle margined>
          Es gilt grundsätzlich zu prüfen, ob ihr Vermieter die richtigen Werte als Grundlage genommen und mit den
          <b>korrekten Umlageschlüsseln</b>
          gerechnet hat. Die exakte Höhe der Nachzahlung ergibt sich aus Vorauszahlung minus den tatsächlich
          angefallenen Kosten.
        </Subtitle>
      </Box>

      <Box mb={2}>
        <Subtitle>
          Vorauszahlung = die im Abrechnungsjahr monatlich zusätzlich zur Kalt-Miete geleisteten Kosten; tatsächlich
          angefallene Kosten = kalte Betriebskosten (ersichtlich aus Betriebskostenverordnung) plus warme Betriebskosten
          (Heizkosten und Warmwasser)
        </Subtitle>
      </Box>
    </Trans>
  );
};

export default AdditionalPaymentHelp;
